<template>
  <div id="pictureList">
    <ul ref="boxUl" :style="{ width: ` calc( 100% + ${marginRight}px ) `,height:setHeight }">
      <li
        :style="{marginRight:marginRight+'px'}"
        v-for="(item,index) in list"
        :key="index"
        @click="goDetails(item)"
      >
        <div class="imgWarp" :style="{width:width,height:height}">
          <img v-if="!textOnCover" v-lazy="item.poster || item.author_poster" alt="图片" />
          <div class="cover-mask" v-if="textOnCover">
            <img v-lazy="item.poster || item.author_poster" alt="图片" />
            <div class="cover-wrap"></div>
          </div>
          <p v-if="textOnCover" class="text-on-cover">{{item.name || item.author_name}}</p>
        </div>
        <template v-if="!textOnCover">
          <el-tooltip
              v-if="showTitle"
              class="item" effect="dark" :content="item.name || item.author_name" placement="top-start">
            <h6
              :style="{color:pageSetup.background==1?'#42476C':'#cccccc'}"
            >{{item.name || item.author_name}}</h6>
          </el-tooltip>
          <p
            v-if="showTime"
            :style="{color:pageSetup.background==1?'#42476C':'#cccccc'}"
          >{{item.year}}{{langTransfer('年')}}{{`0${item.issue}`.substr(-2)}}{{langTransfer('期')}}</p>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "pictureList",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    parent: {
      type: Object,
      default() {
        return undefined;
      }
    },
    width: {
      type: String,
      default() {
        return "183px";
      }
    },
    height: {
      type: String,
      default() {
        return "244px";
      }
    },
    rowNumber: {
      type: Number,
      default() {
        return 4;
      }
    },
    marginRight: {
      type: Number,
      default() {
        return 19;
      }
    },
    showTitle: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      }
    },
    itemClickHandler: {
      type: Function,
      default: undefined
    },
    textOnCover: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    marginNum() {
      return (this.rowNumber - 1) * this.marginRight;
    },
    heightNum() {
      return this.rowNumber + this.height;
    },
    pageSetup() {
      return this.$store.state.pageSetup;
    }
  },
  data() {
    return {
      setHeight: ""
    };
  },
  mounted() {
    this.setHeight = this.$refs.boxUl.offsetHeight - 20 + "px";
  },
  methods: {
    goDetails(item) {
      if (typeof this.itemClickHandler === "function") {
        this.itemClickHandler(item,this.parent);
        return;
      }

      if (this.showTime == true) {
        // this.$router.push({
        //   path: "/journalDetails",
        //   query: { id: item.id, year: item.year, issue: item.issue }
        // });

        const { href } = this.$router.resolve({
          path: "/journalDetails",
            query: { id: item.id, year: item.year, issue: item.issue }
        });
        window.open(href, '_blank');
      } else {

        const { href } = this.$router.resolve({
          path: "/bookDetails",
          query: { id: item.id }
        });
        window.open(href, '_blank');
        // this.$router.push({ path: "/bookDetails", query: { id: item.id } });
      }
      // if (this.showTime == true) {
      //     this.$router.push({ path: '/journalDetails' })

      // } else {
      //     this.$router.push({ path: '/bookDetails' })
      // }
    }
  }
};
</script>
<style scoped lang="less">
#pictureList {
  width: 100%;
  ul {
    // width: 1200px;
    display: flex;
    flex-wrap: wrap;

    // justify-content: space-between;
    li {
      padding: 0 0 20px 0;
      cursor: pointer;

      .imgWarp {
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        overflow: hidden;
        transition: all 1.5s;
        position: relative;

        .cover-mask {
          width: 100%;
          height: 100%;
          position: relative;

          .cover-wrap {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.7) 100%);
            box-shadow:0px 4px 8px 0px rgba(0,0,0,0.1);
            border-radius:4px;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        img {
          width: 100%;
          height: 100%;
          transition: transform 1.5s;
        }

        .text-on-cover {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 16px;
          text-align: center;
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow:ellipsis;
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          // font-weight:600;
          color:rgba(255,255,255,1);
          line-height:16px;
        }
      }
      .imgWarp:hover {
        transform:translateY(-10px)
      }

      h6 {
        max-width: 183px;
        font-size: 16px;
        line-height: 16px;
        margin: 14px 0 8px 0;
        color: #42476c;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      p {
        font-size: 12px;
        color: #42476c;
      }
    }
  }
}
</style>
